import { useQuery } from "react-query";
import { RestError } from "../../services/rest-service/RestService";
import { IQuickTrendViewModel } from "../../services/trending-data-service/Models";
import TrendingDataService from "../../services/trending-data-service/TrendingDataServices";
import { BaseUseQueryParameters } from "../BaseUseQueryParameters";
import { keys } from "./Keys";

export type UseGraphReportOnscreenDataQueryParameters = {
    groupID: number;
    fileStoreID: number;
} & BaseUseQueryParameters<IQuickTrendViewModel>;

export function useGraphReportOnScreenData(params: UseGraphReportOnscreenDataQueryParameters) {
    return useQuery<IQuickTrendViewModel | undefined, RestError>(

        keys.fileStoreData(params.groupID, params.fileStoreID),
        ({ signal }) => {

            return TrendingDataService.getGraphReportOnscreenData(
                params.groupID,
                params.fileStoreID,
                signal
            );
        },
        {
            enabled: params.enabled,
            onError: params.onError,
            onSuccess: params.onSuccess,
            //refetchOnWindowFocus: params.refetchOnWindowFocus
        }
    );
}
